import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const CustomerList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `CustomerList_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.CUSTOMERS,
        method: HttpMethod.GET,
      }),
  };
};
